export default __webpack_public_path__ + "static/media/google-play-badge.1982ce21.png";